import { useState, useEffect } from "react";
import { CheckBadgeIcon, StarIcon } from "@heroicons/react/20/solid";
import { RadioGroup } from "@headlessui/react";
import Navbar from "../components/Navbar";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getProductByIdAsync } from "../slices/ProductListSlice";
import Spinner from "../components/Spinner";
import { addToCartAsync } from "../slices/CartSlice";
import Modal from "../components/Modal";
import { toast } from "react-toastify";
import {
  getAllReviewsByProductIdAsync,
  createReviewAsync,
} from "../slices/ReviewSlice";
import shopping from "../assets/images/shopping.jpg";
import {useNavigate} from "react-router-dom";

const colors = [
  { name: "White", class: "bg-white", selectedClass: "ring-gray-400" },
  { name: "Gray", class: "bg-gray-200", selectedClass: "ring-gray-400" },
  { name: "Black", class: "bg-gray-900", selectedClass: "ring-gray-900" },
];
const sizes = [
  { name: "XXS", inStock: false },
  { name: "XS", inStock: true },
  { name: "S", inStock: true },
  { name: "M", inStock: true },
  { name: "L", inStock: true },
  { name: "XL", inStock: true },
  { name: "2XL", inStock: true },
  { name: "3XL", inStock: true },
];
const highlights = [
  "Hand cut and sewn locally",
  "Dyed with our proprietary colors",
  "Pre-washed & pre-shrunk",
  "Ultra-soft 100% cotton",
];
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const ProductDetails = ({setProgress,search,setSearch,startsearch,setStartSearch}) => {
  const navigate=useNavigate();
  useEffect(() => {
    // callback function to call when event triggers
    const onPageLoad = () => {
      setProgress(100);
    };

    // Check if the page has already loaded
    if (document.readyState === "complete") {
      onPageLoad();
    } else {
      window.addEventListener("load", onPageLoad, false);
      // Remove the event listener when component unmounts
      return () => {
        window.removeEventListener("load", onPageLoad);
        setProgress(0);
      };
    }
  }, []);
  useEffect(()=>{
    if(startsearch  && search!="" ){
      setSearch(search);
      setStartSearch(false)
      navigate("/productpagelist")
    }
    else if(startsearch){
      setStartSearch(false)
    }
  },[search,startsearch])
  const [selectedColor, setSelectedColor] = useState(colors[0]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedSize, setSelectedSize] = useState(sizes[2]);
  const product = useSelector((state) => state.productList.selectedProduct);
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const { id } = useParams();
  const reviews = useSelector((state) => state.reviewList.reviews);
  const [reviewText, setReviewText] = useState("");

  useEffect(() => {
    dispatch(getProductByIdAsync(id));
    dispatch(getAllReviewsByProductIdAsync(id));
  }, [dispatch, id]);

  const addToCart = (e) => {
    if (user) {
      dispatch(addToCartAsync({ ...product, quantity: 1, userId: user.id }));
      // console.log({...product,quantity:1,userId:user.id})
      // console.log(user);
      toast.success(product.title + " added", {
        pauseOnHover: false,
        theme: "dark",
      });
    } else {
      setOpenModal(true);
    }
  };

  const createReview = (e) => {
    if (user) {
      if(reviewText.trim().length!=0 ){
        const date = new Date();
        let currentDate = String(
          `${String(date.getDate()).padStart(2, "0")}/${String(
            date.getMonth() + 1
          ).padStart(2, "0")}/${date.getFullYear()}`
        );
        dispatch(
          createReviewAsync({
            userId: user.id,
            productId: product.id,
            content: reviewText.trim(),
            createdAt: currentDate,
          })
        );
        toast.success("Review added", { pauseOnHover: false, theme: "dark" });
      }
      
    } else {
      setOpenModal(true);
    }
  };

  const navigation =[
    { name: "Home", href: "/", current: false },
    { name: "About", href: "/about", current: false },
    { name: "Products", href: "/productpagelist", current: false },
    { name: "Category", href: "/category", current: false },
    { name: "Deals", href: "/deals", current: false },
  ];
  return (
    <>
      <Navbar navigation={navigation} search={search} setSearch={setSearch} startsearch={startsearch} setStartSearch={setStartSearch} >
        {product ? (
          <div className="bg-white">
            <div className="pt-6">
              <nav aria-label="Breadcrumb">
                <ol
                  role="list"
                  className="mx-auto flex max-w-2xl items-center space-x-2 px-4 sm:px-6 lg:max-w-7xl lg:px-8"
                >
                  {product.breadcrumbs &&
                    product.breadcrumbs.map((breadcrumb) => (
                      <li key={breadcrumb.id}>
                        <div className="flex items-center">
                          <a
                            href={"#"}
                            className="mr-2 text-sm font-medium text-gray-900"
                          >
                            {breadcrumb.name}
                          </a>
                          <svg
                            width={16}
                            height={20}
                            viewBox="0 0 16 20"
                            fill="currentColor"
                            aria-hidden="true"
                            className="h-5 w-4 text-gray-300"
                          >
                            <path d="M5.697 4.34L8.98 16.532h1.327L7.025 4.341H5.697z" />
                          </svg>
                        </div>
                      </li>
                    ))}
                  <li className="text-sm">
                    <a
                      href={"#"}
                      aria-current="page"
                      className="font-medium text-gray-500 hover:text-gray-600"
                    >
                      {product.title}
                    </a>
                  </li>
                </ol>
              </nav>

              {/* Image gallery */}
              <div className="mx-auto mt-6 max-w-2xl sm:px-6 lg:grid lg:max-w-7xl lg:grid-cols-3 lg:gap-x-8 lg:px-8">
                <div className="aspect-h-4 aspect-w-3 hidden overflow-hidden rounded-lg lg:block">
                  <img
                    src={product.images[0]}
                    alt={product.title}
                    className="h-full w-full object-cover object-center"
                  />
                </div>
                <div className="hidden lg:grid lg:grid-cols-1 lg:gap-y-8">
                  <div className="aspect-h-2 aspect-w-3 overflow-hidden rounded-lg">
                    <img
                      src={product.images[1]}
                      alt={product.title}
                      className="h-full w-full object-cover object-center"
                    />
                  </div>
                  <div className="aspect-h-2 aspect-w-3 overflow-hidden rounded-lg">
                    <img
                      src={product.images[2]}
                      alt={product.title}
                      className="h-full w-full object-cover object-center"
                    />
                  </div>
                </div>
                <div className="aspect-h-5 aspect-w-4 lg:aspect-h-4 lg:aspect-w-3 sm:overflow-hidden sm:rounded-lg">
                  <img
                    src={product.images[3]}
                    alt={product.title}
                    className="h-full w-full object-cover object-center"
                  />
                </div>
              </div>

              {/* Product info */}
              <div className="mx-auto max-w-2xl px-4 pb-16 pt-10 sm:px-6 lg:grid lg:max-w-7xl lg:grid-cols-3 lg:grid-rows-[auto,auto,1fr] lg:gap-x-8 lg:px-8 lg:pb-24 lg:pt-16">
                <div className="lg:col-span-2 lg:border-r lg:border-gray-200 lg:pr-8">
                  <h1 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
                    {product.title}
                  </h1>
                </div>

                {/* Options */}
                <div className="mt-4 lg:row-span-3 lg:mt-0">
                  <h2 className="sr-only">Product information</h2>
                  <p className="text-3xl tracking-tight text-gray-900">
                    ₹ {product.price}
                  </p>

                  <div className="mt-6">
                    {/* Colors */}
                    <div>
                      <h3 className="text-sm font-medium text-gray-900">
                        Color
                      </h3>

                      <RadioGroup
                        value={selectedColor}
                        onChange={setSelectedColor}
                        className="mt-4"
                      >
                        <RadioGroup.Label className="sr-only">
                          Choose a color
                        </RadioGroup.Label>
                        <div className="flex items-center space-x-3">
                          {colors.map((color) => (
                            <RadioGroup.Option
                              key={color.name}
                              value={color}
                              className={({ active, checked }) =>
                                classNames(
                                  color.selectedClass,
                                  active && checked ? "ring ring-offset-1" : "",
                                  !active && checked ? "ring-2" : "",
                                  "relative -m-0.5 flex cursor-pointer items-center justify-center rounded-full p-0.5 focus:outline-none"
                                )
                              }
                            >
                              <RadioGroup.Label as="span" className="sr-only">
                                {color.name}
                              </RadioGroup.Label>
                              <span
                                aria-hidden="true"
                                className={classNames(
                                  color.class,
                                  "h-8 w-8 rounded-full border border-black border-opacity-10"
                                )}
                              />
                            </RadioGroup.Option>
                          ))}
                        </div>
                      </RadioGroup>
                    </div>

                    {/* Sizes */}
                    <div className="mt-10">
                      <div className="flex items-center justify-between">
                        <h3 className="text-sm font-medium text-gray-900">
                          Size
                        </h3>
                        <a
                          href="no-referer"
                          className="text-sm font-medium text-indigo-600 hover:text-indigo-500"
                        >
                          Size guide
                        </a>
                      </div>

                      <RadioGroup
                        value={selectedSize}
                        onChange={setSelectedSize}
                        className="mt-4"
                      >
                        <RadioGroup.Label className="sr-only">
                          Choose a size
                        </RadioGroup.Label>
                        <div className="grid grid-cols-4 gap-4 sm:grid-cols-8 lg:grid-cols-4">
                          {sizes.map((size) => (
                            <RadioGroup.Option
                              key={size.name}
                              value={size}
                              disabled={!size.inStock}
                              className={({ active }) =>
                                classNames(
                                  size.inStock
                                    ? "cursor-pointer bg-white text-gray-900 shadow-sm"
                                    : "cursor-not-allowed bg-gray-50 text-gray-200",
                                  active ? "ring-2 ring-indigo-500" : "",
                                  "group relative flex items-center justify-center rounded-md border py-3 px-4 text-sm font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1 sm:py-6"
                                )
                              }
                            >
                              {({ active, checked }) => (
                                <>
                                  <RadioGroup.Label as="span">
                                    {size.name}
                                  </RadioGroup.Label>
                                  {size.inStock ? (
                                    <span
                                      className={classNames(
                                        active ? "border" : "border-2",
                                        checked
                                          ? "border-indigo-500"
                                          : "border-transparent",
                                        "pointer-events-none absolute -inset-px rounded-md"
                                      )}
                                      aria-hidden="true"
                                    />
                                  ) : (
                                    <span
                                      aria-hidden="true"
                                      className="pointer-events-none absolute -inset-px rounded-md border-2 border-gray-200"
                                    >
                                      <svg
                                        className="absolute inset-0 h-full w-full stroke-2 text-gray-200"
                                        viewBox="0 0 100 100"
                                        preserveAspectRatio="none"
                                        stroke="currentColor"
                                      >
                                        <line
                                          x1={0}
                                          y1={100}
                                          x2={100}
                                          y2={0}
                                          vectorEffect="non-scaling-stroke"
                                        />
                                      </svg>
                                    </span>
                                  )}
                                </>
                              )}
                            </RadioGroup.Option>
                          ))}
                        </div>
                      </RadioGroup>
                    </div>

                    <button
                      type="submit"
                      onClick={(e) => {
                        addToCart(e);
                      }}
                      className="mt-10 flex w-full items-center justify-center rounded-md border border-transparent bg-indigo-600 px-8 py-3 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                      Add to Cart
                    </button>
                  </div>
                </div>

                <div className="py-10 lg:col-span-2 lg:col-start-1 lg:border-r lg:border-gray-200 lg:pb-16 lg:pr-8 lg:pt-6">
                  {/* Description and details */}
                  <div>
                    <h3 className="sr-only">Description</h3>

                    <div className="space-y-6">
                      <p className="text-base text-gray-900">
                        {product.description}
                      </p>
                    </div>
                  </div>

                  <div className="mt-10">
                    <h3 className="text-sm font-medium text-gray-900">
                      Highlights
                    </h3>

                    <div className="mt-4">
                      <ul
                        role="list"
                        className="list-disc space-y-2 pl-4 text-sm"
                      >
                        {highlights.map((highlight) => (
                          <li key={highlight} className="text-gray-400">
                            <span className="text-gray-600">{highlight}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  <div className="mt-10">
                    <h2 className="text-sm font-medium text-gray-900 mb-2">
                      Write a Review
                    </h2>
                    <div>
                      <label htmlFor="OrderNotes" className="sr-only">
                        Order notes
                      </label>
                      <div className=" overflow-hidden rounded-lg border border-gray-200 shadow-sm focus-within:border-blue-600 focus-within:ring-1 focus-within:ring-blue-600 p-1">
                        <textarea
                          className="notification w-full resize-none border-none align-top focus:ring-0 sm:text-sm"
                          rows="5"
                          onChange={(e) => setReviewText(e.target.value)}
                          value={reviewText}
                          placeholder="Write your review here ..."
                        />     
                    </div>
                    <div className="flex items-center justify-end gap-2 mt-1 bg-white p-3">
                          <button
                            type="button"
                            onClick={() => setReviewText("")}
                            className="rounded bg-gray-200 px-3 py-1.5 text-sm font-medium text-gray-700 hover:text-gray-600"
                          >
                            Clear
                          </button>

                          <button
                            type="button"
                            className="rounded bg-indigo-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-indigo-700"
                            onClick={(e) => {
                              createReview(e);
                              setReviewText("");
                            }}
                          >
                            Add
                          </button>
                        </div>
                      </div>
                    <h2 className="text-sm font-medium text-gray-900 mt-2 ">
                      Ratings and Reviews
                    </h2>
                    {/* Reviews */}
                    <div className="mt-4 mb-4">
                      <h3 className="sr-only">Reviews</h3>
                      <div className="flex items-center">
                        <div className="flex items-center">
                          {[0, 1, 2, 3, 4].map((rating) => (
                            <StarIcon
                              key={rating}
                              className={classNames(
                                product.rating > rating
                                  ? "text-gray-900"
                                  : "text-gray-200",
                                "h-5 w-5 flex-shrink-0"
                              )}
                              aria-hidden="true"
                            />
                          ))}
                        </div>
                        <p className="sr-only">
                          {product.rating} out of 5 stars
                        </p>
                        <a
                          href={"#"}
                          className="ml-3 text-sm font-medium text-indigo-600 hover:text-indigo-500"
                        >
                          {117} reviews
                        </a>
                      </div>
                    </div>

                    <ul role="list" className="divide-y divide-gray-100">
                      {reviews.map((review) => (
                        <li
                          key={review.id}
                          className="flex justify-between gap-x-6 py-5"
                        >
                          <div className="flex min-w-0 gap-x-4">
                            <img
                              className="h-12 w-12 object-cover flex-none rounded-full bg-gray-50"
                              src={shopping}
                              alt=""
                            />
                            <div className="min-w-0 flex-auto">
                              <p className="text-sm font-semibold  leading-6 text-gray-900">
                                {review.content }
                              </p>
                              <p className="mt-1 truncate text-xs leading-5 text-gray-5 00">
                                {review.userId}
                              </p>
                            </div>
                          </div>
                          <div className="flex ">
                            <div className=" flex items-end flex-col  ">
                              <p className="mt-1 text-xs leading-5 text-gray-500">
                                {review.createdAt}
                              </p>

                              <CheckBadgeIcon className="ri-verified-badge-line h-4 w-4 text-blue-500" />
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                    <div className="mt-4 space-y-6">
                      <p className="text-sm text-gray-600">{product.details}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <Spinner />
        )}
        <Modal open={openModal} setOpen={setOpenModal} />
      </Navbar>
    </>
  );
};

export default ProductDetails;
